module.exports = __webpack_public_path__ + "img/whitetick.5f14b395.png";